/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    CodeAndLabel,
    CodeAndLabelFromJSON,
    CodeAndLabelFromJSONTyped,
    CodeAndLabelToJSON,
    GuidIdCodeAndLabel,
    GuidIdCodeAndLabelFromJSON,
    GuidIdCodeAndLabelFromJSONTyped,
    GuidIdCodeAndLabelToJSON,
    OsisRuleOrderValue,
    OsisRuleOrderValueFromJSON,
    OsisRuleOrderValueFromJSONTyped,
    OsisRuleOrderValueToJSON,
} from './';

/**
 * 
 * @export
 * @interface OsisRuleQuery
 */
export interface OsisRuleQuery {
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof OsisRuleQuery
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {string}
     * @memberof OsisRuleQuery
     */
    description?: string | null;
    /**
     * 
     * @type {CodeAndLabel}
     * @memberof OsisRuleQuery
     */
    fareType?: CodeAndLabel;
    /**
     * 
     * @type {boolean}
     * @memberof OsisRuleQuery
     */
    showDisabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OsisRuleQuery
     */
    showDeleted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OsisRuleQuery
     */
    orderByDescending?: boolean;
    /**
     * 
     * @type {OsisRuleOrderValue}
     * @memberof OsisRuleQuery
     */
    orderValue?: OsisRuleOrderValue;
    /**
     * 
     * @type {GuidIdCodeAndLabel}
     * @memberof OsisRuleQuery
     */
    carrier?: GuidIdCodeAndLabel;
    /**
     * 
     * @type {number}
     * @memberof OsisRuleQuery
     */
    offset?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OsisRuleQuery
     */
    limit?: number | null;
}

export function OsisRuleQueryFromJSON(json: any): OsisRuleQuery {
    return OsisRuleQueryFromJSONTyped(json, false);
}

export function OsisRuleQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): OsisRuleQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'fareType': !exists(json, 'fareType') ? undefined : CodeAndLabelFromJSON(json['fareType']),
        'showDisabled': !exists(json, 'showDisabled') ? undefined : json['showDisabled'],
        'showDeleted': !exists(json, 'showDeleted') ? undefined : json['showDeleted'],
        'orderByDescending': !exists(json, 'orderByDescending') ? undefined : json['orderByDescending'],
        'orderValue': !exists(json, 'orderValue') ? undefined : OsisRuleOrderValueFromJSON(json['orderValue']),
        'carrier': !exists(json, 'carrier') ? undefined : GuidIdCodeAndLabelFromJSON(json['carrier']),
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}

export function OsisRuleQueryToJSON(value?: OsisRuleQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'description': value.description,
        'fareType': CodeAndLabelToJSON(value.fareType),
        'showDisabled': value.showDisabled,
        'showDeleted': value.showDeleted,
        'orderByDescending': value.orderByDescending,
        'orderValue': OsisRuleOrderValueToJSON(value.orderValue),
        'carrier': GuidIdCodeAndLabelToJSON(value.carrier),
        'offset': value.offset,
        'limit': value.limit,
    };
}


